/**
 * CSV building and download, for report exports assembled in the browser
 * rather than fetched from the API.
 */

/** RFC 4180: quote a value containing a comma, quote, CR or LF; double inner quotes. */
function escapeCell(value: string | number): string {
  const text = String(value ?? '');
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

/** Header row plus body rows as CSV text, CRLF-delimited per the spec. */
export function toCsv(headers: readonly string[], rows: readonly (readonly (string | number)[])[]): string {
  return [headers, ...rows].map(row => row.map(escapeCell).join(',')).join('\r\n');
}

/**
 * Hands a CSV to the browser as a download.
 *
 * The leading BOM is what makes Excel read the file as UTF-8 rather than the
 * system codepage; without it any non-ASCII character arrives mangled.
 */
export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob(['﻿', csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
